'use strict'

module.exports = {
    project_name: 'hanland',
    package_name: 'hanland',
    port: 8000,
    // url: '/local'
    // url: 'http://manage.handev.com'
    url: process.env.VUE_APP_BASEURL
}
